import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssetEventSelectorId } from '../../utils/hsAnalytics';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { LessonIcon } from 'foundations-assets/icons/components/LessonIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssetSetupGuideButton = ({
  offeringType,
  setupUrl
}) => {
  const {
    trackDetailsInteraction
  } = useContext(StorefrontUsageTrackerContext);
  return /*#__PURE__*/_jsxs(Button, {
    "data-hs-analytics-id": getAssetEventSelectorId('SETUP-GUIDE', offeringType),
    href: setupUrl,
    hideExternalLinkIcon: true,
    external: true,
    onClick: () => trackDetailsInteraction('click setup guide link', {
      section: 'header'
    }),
    use: "link",
    children: [/*#__PURE__*/_jsx(LessonIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.details.setupGuide"
    })]
  });
};
export default AssetSetupGuideButton;